module.exports = __webpack_public_path__ + "img/wa08.296cffb4.jpg";